import React, { useMemo } from 'react';
import classNames from 'classnames';
import { DataRoomRoute } from '../../models/Route';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCallbackRef from 'hooks/useCallbackRef';
import useHeightAnimation from 'hooks/useHeightAnimation';
import { Button } from 'ncoded-component-library';

import './DataRoomSubrouterNavigation.styles.scss';
import './DataRoomSubrouterNavigation.styles.responsive.scss';

type DataRoomSubrouterNavigationProps = {
  className?: string;
  routes: Array<DataRoomRoute>;
};

const DataRoomSubrouterNavigation: React.FC<
  DataRoomSubrouterNavigationProps
> = (props) => {
  const { className, routes = [] } = props;
  const { t } = useTranslation();
  const [container, containerRef] = useCallbackRef(null);
  const {
    open,
    setOpen,
    classes: navigationContainerClasses,
  } = useHeightAnimation({
    element: container,
  });

  const classes = classNames(
    'data-room-subrouter-navigation',
    navigationContainerClasses,
    className,
  );

  const RenderedRoutesList = useMemo(
    () => (
      <ul>
        {routes.map(({ path, labelString }) => (
          <li key={path}>
            <NavLink
              to={path}
              className={(isActive) => {
                if (isActive) return 'active';
              }}
            >
              {t(labelString)}
            </NavLink>
          </li>
        ))}
      </ul>
    ),
    [routes, t],
  );

  return (
    !!routes.length && (
      <>
        <nav ref={containerRef} className={classes}>
          {RenderedRoutesList}
        </nav>
        <Button
          className="data-room-subrouter-navigation-button"
          onClick={() => setOpen((old) => !old)}
        >
          {t(open ? 'closeNavigation' : 'openNavigation')}
        </Button>
      </>
    )
  );
};

export default DataRoomSubrouterNavigation;
